import React from "react";
import * as S from "./styled";
import PT from "prop-types";
import { CurrencyFormatter } from "@/i18n/currency";
import Avatar from "_c/Avatar";
import ClockIcon from "_c/icon/Clock";
import { formatMinutes } from "@/utils/time";
import Tooltip from "_c/Tooltip";
import BagIcon from "_c/icon/BagPlus";
import { Link } from "react-router-dom";
import { LinkGenerator } from "@/utils/LinkGenerator";
import BasketUnitPopover from "_c/Popover/BasketUnitPicker";
import CheckmarkIcon from "_c/icon/Checkmark";
import { SALOON_NS as ns } from "@/i18n/ns";
import { CircleButton } from "_c/button";
import GearIcon from "_c/icon/Gear";
import TrashIcon from "_c/icon/Trash";

const SaloonServiceView = ({
  selectedMaster: master,
  t,
  service,
  ...props
}) => {
  return (
    <S.Wrap>
      {master ? (
        <div>
          <S.SelectedMaster>
            <strong>{t(`${ns}:services.selected_master`)}:</strong>
            <S.AvatarAndName>
              <Avatar
                avatar={master.user.avatar}
                online={master.user.online}
                sex={master.user.sex}
                online_at={master.user.online_at}
              />
              <Link to={LinkGenerator.masterProfile(master._id)}>
                <S.MasterName>
                  {[master.user.first_name, master.user.last_name]
                    .filter(Boolean)
                    .join(" ")}
                </S.MasterName>
              </Link>
            </S.AvatarAndName>
          </S.SelectedMaster>
          {service && (
            <div>
              <S.Title>{props.title}</S.Title>
              <S.Info>
                {props.oldPrice && (
                  <S.OldPrice as="strike">
                    <span>{CurrencyFormatter.format(props.oldPrice)}</span>
                  </S.OldPrice>
                )}
                <S.Price>
                  <span>{CurrencyFormatter.format(props.finalPrice)}</span>
                  {service.per_unit && (
                    <>
                      <S.PriceUnitDelim>/</S.PriceUnitDelim>
                      <S.Unit>{service.unit_name}</S.Unit>
                    </>
                  )}
                </S.Price>
                <S.Duration>
                  <ClockIcon width="14" color="var(--font-color-emp)" />
                  <span>{formatMinutes(service.duration)}</span>
                </S.Duration>
                {service.desc && (
                  <Tooltip title={service.desc}>
                    <S.DescLabel small>i</S.DescLabel>
                  </Tooltip>
                )}
              </S.Info>
              {service.disable_booking && (
                <div
                  css={`
                    color: var(--color-danger);
                    margin-top: 5px;
                  `}
                >
                  {t(`${ns}:services.booking_disabled`)}
                </div>
              )}
              {props.canEditServices && (
                <div
                  css={`
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    @media (max-width: 550px) {
                      justify-content: center;
                    }
                    button {
                      font-weight: 700;
                      margin-inline-end: 10px;
                      :last-child {
                        margin-inline-end: 0;
                      }
                    }
                  `}
                >
                  <CircleButton
                    title={t("common:change")}
                    onClick={props.openEditor}
                  >
                    <GearIcon width="20" color="white" />
                  </CircleButton>
                  {props.isOwner && (
                    <CircleButton
                      light
                      title={t("common:discount_editor.new")}
                      onClick={props.toggleDiscountEditor}
                    >
                      %
                    </CircleButton>
                  )}
                  <CircleButton
                    title={t("common:remove")}
                    disabled={props.removeMut.isLoading}
                    onClick={props.removeMut.mutate}
                    negative
                  >
                    <TrashIcon width="20" />
                  </CircleButton>
                </div>
              )}
              {props.isInBasket && (
                <S.InBasketWrap>
                  <S.InBasketBadge>
                    <CheckmarkIcon width="12" color="white" />
                  </S.InBasketBadge>
                  <strong>{t(`${ns}:services.basket_has`)}</strong>
                </S.InBasketWrap>
              )}
              {!service.disable_booking &&
                props.canAddToBasket &&
                !props.isInBasket &&
                (service.per_unit ? (
                  <BasketUnitPopover
                    t={t}
                    onSubmit={props.addToBasket}
                    unitName={service.unit_name}
                  >
                    <S.BasketButton withIcon greenish>
                      <BagIcon color="white" />
                      <span>{t(`${ns}:services.basket_add`)}</span>
                    </S.BasketButton>
                  </BasketUnitPopover>
                ) : (
                  <S.BasketButton withIcon onClick={props.addToBasket} greenish>
                    <BagIcon color="white" />
                    <span>{t(`${ns}:services.basket_add`)}</span>
                  </S.BasketButton>
                ))}
            </div>
          )}
        </div>
      ) : (
        <S.NoMasterContainer>
          <S.Title>{props.title}</S.Title>
          <S.AvgPrice>
            <span>{t(`${ns}:services.avg_price`)}: </span>{" "}
            <S.Price>{CurrencyFormatter.format(props.avgPrice)}</S.Price>
          </S.AvgPrice>
          <S.NoMasterAttention>
            <span>i</span>
            <span>{t(`${ns}:services.choose_master`)}</span>
          </S.NoMasterAttention>
        </S.NoMasterContainer>
      )}
      {props.MasterSelector}
    </S.Wrap>
  );
};
SaloonServiceView.propTypes = {
  title: PT.string,
  MasterSelector: PT.any,
  selectedMaster: PT.object,
  service: PT.object,
  isInBasket: PT.bool,
  canAddToBasket: PT.bool,
  canEditServices: PT.bool,
  isOwner: PT.bool,
  removeMut: PT.object.isRequired,

  toggleDiscountEditor: PT.func.isRequired,
  openEditor: PT.func.isRequired,
  t: PT.func.isRequired,
  addToBasket: PT.func.isRequired,
};
export default SaloonServiceView;
